export default "__VITE_ASSET__CRhy8XvD__"